<template>
    <div>
        <v-dialog v-model="ModalNotaCredito"  max-width="800" class="primary">
            <v-toolbar  dark color="primary" class="font-weight-light body-1">
                <h4>Recarga a {{localidad}}</h4>
                
            </v-toolbar>
            <v-card>
            <v-container fluid>
                <v-col cols="12" class="mt--3" sm="12">
                <v-form ref="form" v-model="validFactura"  @submit.prevent="facturar">
                <v-row > 
                    <v-col  cols="12" sm="12">
                        <v-select v-model="recarga" @change="Get()" :items="recargas" label="Cantidad"></v-select>
                    </v-col>
                    
                    <v-col cols="12" sm="12">
                        <v-text-field v-model="Mensaje" label="Referencia de transferencia"></v-text-field>
                    </v-col>
                        <v-col cols="12" sm="12">
                        <v-btn  color="primary" :loading="loading" class="mr-4" style="top: 10px;" @click="Actualizar()">
                        Aplicar Recarga
                        </v-btn>
                        <v-btn color="error" id="espacioBoton" @click="ModalNotaCredito = false">
                        Cancelar
                        </v-btn> 
                        </v-col>
                </v-row>
                </v-form>
                </v-col>
            </v-container>
            </v-card>
        </v-dialog>
        <v-data-table
            :headers="headers"
            :items="usuarios"
            :search="search"

            >
            <template v-slot:item.estado="{ item }">
            <v-chip :color="getColor(item.planNoah)" dark>{{ item.planNoah }}</v-chip>
            </template>
            <template v-slot:top>
                <v-row class="pa-2">
                    <v-col cols="12" sm="3">
                            <v-card-title>Recargas</v-card-title>
                    </v-col>
                    <v-col cols="12" sm="4">    
                        <v-text-field v-model="search"  append-icon="mdi-magnify"
                         label="Buscar" single-line hide-details
                        ></v-text-field>
                    </v-col>
                </v-row>
               
            </template>
			<template v-slot:item.limiteFact="props">
				<v-edit-dialog
					:return-value.sync="props.item.limiteFact"
					@save="ActualizarCantidad(props.item)"
					@cancel="cancel"
					@open="open"
					@close="close"
					>
					{{ props.item.limiteFact }} <br>
					<template v-slot:input>
						<v-text-field
						onfocus="this.select();"
						v-model="props.item.limiteFact"
						
						:rules="[max25chars]"
						:label="'Cantidad de Facturas a cargar: '"
						></v-text-field>
					</template>
				</v-edit-dialog>
			</template>
            <template v-slot:item.action="{ item }">
                <v-menu top :offset-y="offset">
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        small
                        fab=""
                        v-bind="attrs"
                        v-on="on"
                        
                    > <v-icon color="info">mdi-dots-horizontal</v-icon>
                    </v-btn>
                    </template>
                    <v-list>
						<v-list-item @click="MostrarComprobante(item)">
							<v-list-item-title><v-icon >mdi-file-document</v-icon> 
								Recargar
							</v-list-item-title>
						</v-list-item>
                    </v-list>
                </v-menu>
            <template >
            </template>
            </template>

            <template v-slot:no-data>
                <v-data-table item-key="name" class="elevation-1" loading loading-text="Cargando datos... Por favor espere"></v-data-table>
                <v-btn color="primary" @click="initialize">Reiniciar</v-btn>
            </template>
        </v-data-table>
        <template class="pa-3">
            <v-snackbar
                    v-model="snackbar" top vertical="" :timeout="5000"
                    >
                    {{ Mensaje }}
                    <v-btn
                    color="info"
                    text
                    @click="snackbar = false"
                    >
                    Cerrar
                    </v-btn>
            </v-snackbar>
            
            <v-row flat color="white"  class="pa-2">
                <v-row flat color="white"  class="rounded-xl light-blue lighten-5 mx-5">
                <v-card-text>
                    <b> Total de Clientes:  </b> {{usuarios.length}} <br>
                    <b> Total Mensuales:</b>  {{totalActivos}} <br>
                    <b> Total Prepago:</b>  {{totalInactivos}} <br>
                    
                 
                </v-card-text>
                </v-row>
                <v-col cols="12" sm="6">
                    <canvas id="myChart" class="rounded-xl light-blue lighten-5 mx-5">
                        
                    </canvas>
                </v-col>
            </v-row>
        </template>
    </div>
</template>

<script scoped>
import axios from 'axios'
import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";
import QrcodeVue from 'qrcode.vue'

Vue.use(VueExcelXlsx);
  export default {
    data: () => ({
    mesesValores: null,
    nombreMeses: [],
    totalMeses: [],
    value: 'https://www.noah.cr',
    size: 100,
	localidad: "",
	estado: 0,
	Mensaje: "",
    dialog: false,
	loading : false,
    Aceptadas: 0,
    esIVI: false,
    search: '',
    ClienteSeleccionado : '',
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    headers: [
	{ text: 'Opciones', value: 'action', sortable: false },
    { text: 'Cliente', value: 'localidad' },
    { text: 'Plan', value: 'estado' },
    { text: 'Monto Licencia', value: 'montoLicencia' },
    { text: 'Limite Facturas', value: 'limiteFact' },
    { text: 'Fact Realizadas', value: 'facturaMes' },
    { text: 'Saldo', value: 'saldoFacturas' },
    ],
    recargas: [
        {text:'10 Facturas c5.000', value: 10},
        {text:'20 Facturas c10.000', value: 20},
        {text:'100 Facturas c15.000', value: 100},
        {text:'200 Facturas c20.000', value: 200},
        {text:'600 Facturas c40.000', value: 600},
    ],
    PagosFiltrados: "",
    Monedas: ["USD","CRC"],
    TiposPago:["TARJETA","DEPOSITO","EFECTIVO","TRANSFERENCIA"],

    MonedaFiltrar : "",
    tipoCedulaReceptor: '',
      search: '',
    id: '',
    idrol:'',
    noFactura: 0,
    nofactura2: '/ticket/2',
    comprobanteModal: 0,
    Mensajes: ["Su licencia se encuentra vencida por falta de pago, si ya cancelo por favor reporte a su proveedor" ,"Prorroga temporal activada"," Licencia Activada","Cliente de Baja"],
    productosDatos:[],
    MensajeRespuesta: '',
    ClaveComprobante: '',
    texto: "",
    ModalNotaCredito: false,
	limite: 0,
    snackbar: false,
    Mensaje: "",
    correo: '',
    VendedorSeleccionado: '',
    total: 0,
    justificacion: '',
    medioDePago : '',
	estadoXML: 0,
    detalles: [],
    localidadencabezado:[],
    NombreLocalidad:'',
    CedulaLocalidad:'',
    Datos: [],
    DireccionLocalidad:'',
    Logo3: '',
    TelefonoLocalidad:'',
	excento: 0,
	ShowNoFact: false,
	Cuentas: '',
    Logo2 : '',
    iv: 0.0,
    clientes: [],
    start : '',
    end : '',
    tipo_documento: '',
    Vendedores: [],
	usuarios:[],    
	modoPDV: 0,
    desserts: [],
    editedIndex: -1,
    descuento: 0,
    
    }),
    components: {
      QrcodeVue,
    },

    computed: {
    formTitle () {
            return this.editedIndex === -1 ? 'Nuevo usuario' : 'Actualizar usuario'
    },
    totalActivos:function(){
        var resultado=0.0;
          for(var i=0;i<this.usuarios.length;i++){
			  	if(this.usuarios[i].planNoah == "Mensual") {
					 resultado=resultado+1
				  }
          }
        
        return resultado.toFixed(2);
      },
	  totalInactivos:function(){
        var resultado=0.0;
          for(var i=0;i<this.usuarios.length;i++){
			  	if(this.usuarios[i].planNoah == "Prepago") {
					 resultado=resultado+1
				  }
          }
        
        return resultado.toFixed(2);
      },
    },
    

    watch: {
      dialog (val) {
        val || this.close()
      },
      
    },

    created () {
      	this.listar();
    },
    methods: {
       	async listar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};
            await axios.get('api/RepVentasVistas/ListarPlanes',configuracion).then(function(response){
                //console.log(response);
                me.usuarios=response.data;
            }).catch(function(error){
                alert(error)
            });
        },
		async ActualizarCantidad(item){
			let me=this;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			await axios.put('api/Localidades/ActivarDesactivar',{
					'Nombre':item.localidad,
					'LimiteFact':item.limiteFact,
			},configuracion).then(function(response){
				//console.log(response);
				me.snackbar = true;
				me.Mensaje = 'Cantidad Actualizada con éxito';
				me.listar()
			}).catch(function(error){
				alert(error)
			});
		},
			async Actualizar () {
			
			this.limite = this.limite + this.recarga;
			var email = 
			`<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
				<html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office" style="width:100%;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
				<head>
				<meta charset="UTF-8">
				<meta content="width=device-width, initial-scale=1" name="viewport">
				<meta name="x-apple-disable-message-reformatting">
				<meta http-equiv="X-UA-Compatible" content="IE=edge">
				<meta content="telephone=no" name="format-detection">
				<title>Nuevo mensaje</title>
				<!--[if (mso 16)]>
				<style type="text/css">
				a {text-decoration: none;}
				</style>
				<![endif]-->
				<!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]-->
				<!--[if gte mso 9]>
				<xml>
				<o:OfficeDocumentSettings>
				<o:AllowPNG></o:AllowPNG>
				<o:PixelsPerInch>96</o:PixelsPerInch>
				</o:OfficeDocumentSettings>
				</xml>
				<![endif]-->
				<!--[if !mso]><!-- -->
				<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700,700i" rel="stylesheet">
				<link href="https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i" rel="stylesheet">
				<!--<![endif]-->
				<style type="text/css">
				#outlook a {
				padding:0;
				}
				.ExternalClass {
				width:100%;
				}
				.ExternalClass,
				.ExternalClass p,
				.ExternalClass span,
				.ExternalClass font,
				.ExternalClass td,
				.ExternalClass div {
				line-height:100%;
				}
				.es-button {
				mso-style-priority:100!important;
				text-decoration:none!important;
				}
				a[x-apple-data-detectors] {
				color:inherit!important;
				text-decoration:none!important;
				font-size:inherit!important;
				font-family:inherit!important;
				font-weight:inherit!important;
				line-height:inherit!important;
				}
				.es-desk-hidden {
				display:none;
				float:left;
				overflow:hidden;
				width:0;
				max-height:0;
				line-height:0;
				mso-hide:all;
				}
				[data-ogsb] .es-button {
				border-width:0!important;
				padding:15px 30px 15px 30px!important;
				}
				@media only screen and (max-width:600px) {p, ul li, ol li, a { line-height:150%!important } h1 { font-size:32px!important; text-align:center; line-height:120%!important } h2 { font-size:26px!important; text-align:center; line-height:120%!important } h3 { font-size:20px!important; text-align:center; line-height:120%!important } .es-header-body h1 a, .es-content-body h1 a, .es-footer-body h1 a { font-size:32px!important } .es-header-body h2 a, .es-content-body h2 a, .es-footer-body h2 a { font-size:26px!important } .es-header-body h3 a, .es-content-body h3 a, .es-footer-body h3 a { font-size:20px!important } .es-menu td a { font-size:16px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:16px!important } .es-content-body p, .es-content-body ul li, .es-content-body ol li, .es-content-body a { font-size:16px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:16px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class="gmail-fix"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:inline-block!important } a.es-button, button.es-button { font-size:16px!important; display:inline-block!important; border-width:15px 30px 15px 30px!important } .es-btn-fw { border-width:10px 0px!important; text-align:center!important } .es-adaptive table, .es-btn-fw, .es-btn-fw-brdr, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0px!important } .es-m-p0r { padding-right:0px!important } .es-m-p0l { padding-left:0px!important } .es-m-p0t { padding-top:0px!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } tr.es-desk-hidden, td.es-desk-hidden, table.es-desk-hidden { width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } tr.es-desk-hidden { display:table-row!important } table.es-desk-hidden { display:table!important } td.es-desk-menu-hidden { display:table-cell!important } .es-menu td { width:1%!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } }
				</style>
				</head>
				<body style="width:100%;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0">
				<div class="es-wrapper-color" style="background-color:#EEEEEE">
				<!--[if gte mso 9]>
				<v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
				<v:fill type="tile" color="#eeeeee"></v:fill>
				</v:background>
				<![endif]-->
				<table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td valign="top" style="padding:0;Margin:0">
				<table cellpadding="0" cellspacing="0" class="es-content" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:10px;padding-right:10px;padding-top:15px;padding-bottom:15px">
				<!--[if mso]><table style="width:580px" cellpadding="0" cellspacing="0"><tr><td style="width:282px" valign="top"><![endif]-->
				<table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:282px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td class="es-infoblock es-m-txt-c" align="left" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px">Recibo de nueva recarga</p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td><td style="width:20px"></td><td style="width:278px" valign="top"><![endif]-->
				<table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:278px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="right" class="es-infoblock es-m-txt-c" style="padding:0;Margin:0;line-height:14px;font-size:12px;color:#CCCCCC"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:14px;color:#CCCCCC;font-size:12px"><a href="https://viewstripo.email" class="view" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#CCCCCC;font-size:12px;font-family:arial, 'helvetica neue', helvetica, sans-serif">Ver correo desde el navegador</a></p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td></tr></table><![endif]--></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse"></tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-header-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#044767;width:600px" cellspacing="0" cellpadding="0" bgcolor="#044767" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-top:35px;padding-bottom:35px;padding-left:35px;padding-right:35px">
				<!--[if mso]><table style="width:530px" cellpadding="0" cellspacing="0"><tr><td style="width:340px" valign="top"><![endif]-->
				<table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
				<tr style="border-collapse:collapse">
				<td class="es-m-p0r es-m-p20b" valign="top" align="center" style="padding:0;Margin:0;width:340px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;font-size:0px"><a target="_blank" href="https://www.noah.cr" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#FFFFFF;font-size:14px"><img class="adapt-img" src="https://lezqhg.stripocdn.email/content/guids/CABINET_2a7984966d297aaa4a76118cda60b02d/images/67371618634728603.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="45"></a></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td><td style="width:20px"></td><td style="width:170px" valign="top"><![endif]-->
				<table cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr class="es-hidden" style="border-collapse:collapse">
				<td class="es-m-p20b" align="left" style="padding:0;Margin:0;width:170px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:5px;font-size:0">
				<table width="100%" height="100%" cellspacing="0" cellpadding="0" border="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0;border-bottom:1px solid #044767;background:#FFFFFF none repeat scroll 0% 0%;height:1px;width:100%;margin:0px"></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td style="padding:0;Margin:0">
				<table cellspacing="0" cellpadding="0" align="right" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="right" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#FFFFFF;font-size:14px">Recibo de Recarga</p></td>
				</tr>
				</table></td>
				<td valign="top" align="left" style="padding:0;Margin:0;padding-left:10px;font-size:0"><a href="https://www.noah.cr" target="_blank" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#FFFFFF;font-size:14px"><img src="https://lezqhg.stripocdn.email/content/guids/CABINET_75694a6fc3c4633b3ee8e3c750851c02/images/77981522050090360.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="27"></a></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td></tr></table><![endif]--></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-left:35px;padding-right:35px;padding-top:40px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="Margin:0;padding-top:25px;padding-bottom:25px;padding-left:35px;padding-right:35px;font-size:0"><a target="_blank" href="https://www.noah.cr" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#ED8E20;font-size:16px"><img src="https://lezqhg.stripocdn.email/content/guids/CABINET_75694a6fc3c4633b3ee8e3c750851c02/images/67611522142640957.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="120"></a></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:10px"><h2 style="Margin:0;line-height:36px;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;font-size:30px;font-style:normal;font-weight:bold;color:#333333">Nueva recarga de facturas!</h2></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-top:15px;padding-bottom:20px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#777777;font-size:16px">Felicidades `+this.localidad+` tu recargada de  `+this.recarga+` documentos ha sido aplicada</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-top:20px;padding-left:35px;padding-right:35px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td bgcolor="#eeeeee" align="left" style="Margin:0;padding-top:10px;padding-bottom:10px;padding-left:10px;padding-right:10px">Orden
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:500px" class="cke_show_border" cellspacing="1" cellpadding="1" border="0" align="left" role="presentation">
				<tr style="border-collapse:collapse">
				<td width="80%" style="padding:0;Margin:0"></td>
				<td width="20%" style="padding:0;Margin:0"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">Cantidad Recargada</h4></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-left:35px;padding-right:35px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-top:10px;padding-bottom:10px;padding-left:10px;padding-right:10px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:500px" class="cke_show_border" cellspacing="1" cellpadding="1" border="0" align="left" role="presentation">
				<tr style="border-collapse:collapse">
				<td style="padding:5px 10px 5px 0;Margin:0" width="80%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">`+this.texto+`</p></td>
				<td style="padding:5px 0;Margin:0" width="20%" align="left"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">`+this.recarga+`</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-top:10px;padding-left:35px;padding-right:35px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;border-top:3px solid #EEEEEE;border-bottom:3px solid #EEEEEE" width="100%" cellspacing="0" cellpadding="0" role="presentation">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:10px;padding-right:10px;padding-top:15px;padding-bottom:15px">
				<table style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;width:500px" class="cke_show_border" cellspacing="1" cellpadding="1" border="0" align="left" role="presentation">
				<tr style="border-collapse:collapse">
				<td width="80%" style="padding:0;Margin:0"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">TOTAL DISPONIBLE</h4></td>
				<td width="20%" style="padding:0;Margin:0"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">`+this.limite +`</h4></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:35px;padding-right:35px;padding-top:40px;padding-bottom:40px">
				<!--[if mso]><table style="width:530px" cellpadding="0" cellspacing="0"><tr><td style="width:255px" valign="top"><![endif]-->
				<table class="es-left" cellspacing="0" cellpadding="0" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left">
				<tr style="border-collapse:collapse">
				<td class="es-m-p20b" align="left" style="padding:0;Margin:0;width:255px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-bottom:15px"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">Dirección</h4></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-bottom:10px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">San José, CR</p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td><td style="width:20px"></td><td style="width:255px" valign="top"><![endif]-->
				<table class="es-right" cellspacing="0" cellpadding="0" align="right" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:right">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;width:255px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0;padding-bottom:15px"><h4 style="Margin:0;line-height:120%;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif">Fecha</h4></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="left" style="padding:0;Margin:0"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:24px;color:#333333;font-size:16px">`+this.today+`</p></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<!--[if mso]></td></tr></table><![endif]--></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#1F4168;width:600px" cellspacing="0" cellpadding="0" bgcolor="#1F4168" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-top:35px;padding-bottom:35px;padding-left:35px;padding-right:35px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-top:25px"><h2 style="Margin:0;line-height:29px;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;font-size:24px;font-style:normal;font-weight:bold;color:#FFFFFF">Historial de recargas</h2></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="Margin:0;padding-left:10px;padding-right:10px;padding-bottom:15px;padding-top:30px"><span class="es-button-border" style="border-style:solid;border-color:transparent;background:#42A5F6;border-width:0px;display:inline-block;border-radius:5px;width:auto"><a href="https://www.noah.cr/recargas/0" class="es-button" target="_blank" style="mso-style-priority:100 !important;text-decoration:none;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;color:#FFFFFF;font-size:18px;border-style:solid;border-color:#42A5F6;border-width:15px 30px 15px 30px;display:inline-block;background:#42A5F6;border-radius:5px;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;font-weight:normal;font-style:normal;line-height:22px;width:auto;text-align:center">Ver Historial de recargas</a></span></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0"><h2 style="Margin:0;line-height:62px;mso-line-height-rule:exactly;font-family:roboto, 'helvetica neue', helvetica, arial, sans-serif;font-size:31px;font-style:normal;font-weight:bold;color:#FFFFFF"><strong>Promociones para Punto de Venta</strong></h2></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;font-size:0px"><img class="adapt-img" src="https://lezqhg.stripocdn.email/content/guids/CABINET_2a7984966d297aaa4a76118cda60b02d/images/26431623117461501.jpg" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="530"></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;font-size:0px"><img class="adapt-img" src="https://lezqhg.stripocdn.email/content/guids/CABINET_2a7984966d297aaa4a76118cda60b02d/images/28181623117484566.jpg" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="530"></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0"><a target="_blank" href="https://www.youtube.com/watch?v=i04F_bgT59A&t=24s" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;text-decoration:none;color:#ED8E20;font-size:16px"><img class="adapt-img" src="https://lezqhg.stripocdn.email/content/guids/videoImgGuid/images/82591623117286616.png" alt="Demostración Tienda en Linea para Restaurantes" width="530" title="Demostración Tienda en Linea para Restaurantes" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic"></a></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table cellpadding="0" cellspacing="0" class="es-footer es-visible-simple-html-only" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;background-color:transparent;background-repeat:repeat;background-position:center top">
				<tr style="border-collapse:collapse">
				<td class="es-stripe-html" align="center" style="padding:0;Margin:0">
				<table class="es-footer-body" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#FFFFFF;width:600px">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-top:35px;padding-left:35px;padding-right:35px;padding-bottom:40px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:530px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:15px;font-size:0px"><img src="https://lezqhg.stripocdn.email/content/guids/CABINET_2a7984966d297aaa4a76118cda60b02d/images/67371618634728603.png" alt="Beretun logo" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" title="Beretun logo" width="37"></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;padding-bottom:35px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#333333;font-size:14px"><b>Enviado por Noah Systems CR</b></p></td>
				</tr>
				<tr style="border-collapse:collapse">
				<td esdev-links-color="#777777" align="left" class="es-m-txt-c" style="padding:0;Margin:0;padding-bottom:5px"><p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:'open sans', 'helvetica neue', helvetica, arial, sans-serif;line-height:21px;color:#777777;font-size:14px">Este correo fue generado de forma automática, por favor no responda ya que no obtendrá respuesta</p></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				<table class="es-content" cellspacing="0" cellpadding="0" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0">
				<table class="es-content-body" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:transparent;width:600px" cellspacing="0" cellpadding="0" align="center">
				<tr style="border-collapse:collapse">
				<td align="left" style="Margin:0;padding-left:20px;padding-right:20px;padding-top:30px;padding-bottom:30px">
				<table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td valign="top" align="center" style="padding:0;Margin:0;width:560px">
				<table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px">
				<tr style="border-collapse:collapse">
				<td align="center" style="padding:0;Margin:0;font-size:0px"><img class="adapt-img" src="https://lezqhg.stripocdn.email/content/guids/CABINET_2a7984966d297aaa4a76118cda60b02d/images/67371618634728603.png" alt style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic" width="140"></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table></td>
				</tr>
				</table>
				</div>
				</body>
				</html>`;
			this.loading = true;
			var me = this;
			if(confirm("Seguro que recargar "+me.Mensaje+" a  "+me.localidad+"?")){
				let header={"Authorization" : "Bearer " + this.$store.state.token};
				let configuracion= {headers : header};
				await axios.post('api/Localidades/Recargar',{
					'LimiteFact': me.limite,
					'Nombre': me.localidad,
					'Mensaje': me.Mensaje,
					'Correo': me.correo,
					'Mail':email,
					'Usuario':me.$store.state.usuario.nombre,
						
				},configuracion).then(function (response) {
					
					me.snackbar = true;
					me.Mensaje = 'Recarga realizada con éxito.'; 
					me.loading = false;
					me.ModalNotaCredito = false;
					me.listar();
					
					})
					.catch(function (error) {
						me.snackbar = true;
						me.Mensaje = 'Error recargando.';    
					})
			}
		},
		getColor (estado) {
			if (estado == 'Prepago') return 'indigo'
			if(estado == 'Mensual') return '#42A5F5'
			else  return '#8BC34A'
		},
	  	MostrarComprobante(item){
		  	this.correo = item.correo;
		  	this.ModalNotaCredito = true;
            this.localidad= item.localidad;
			this.limite = item.limiteFact;
        },
		Get(){
			if(this.recarga == 10){
				this.texto = '10 Facturas c5.000';
			} else
			if(this.recarga == 20){
				this.texto = '20 Facturas c10.000';
			} else
			if(this.recarga == 100){
				this.texto = '100 Facturas c15.000';
			} else
			if(this.recarga == 200){
				this.texto = '200 Facturas c20.000';
			} else
			if(this.recarga == 600){
				this.texto = '600 Facturas c40.000';
			} 
		},

		ObtenerTexto(){
			if(this.recarga == 10){
				this.texto = '10 Facturas c5.000';
			} else
			if(this.recarga == 20){
				this.texto = '20 Facturas c10.000';
			} else
			if(this.recarga == 100){
				this.texto = '100 Facturas c15.000';
			} else
			if(this.recarga == 200){
				this.texto = '200 Facturas c20.000';
			} else
			if(this.recarga == 600){
				this.texto = '600 Facturas c40.000';
			} 

		},
      close () {
        this.dialog = false;
        this.limpiar();
          },
    

      activarDesactivarMostrar(accion,item){
                this.adModal=1;
                this.adNombre=item.nombre;
                this.adId=item.idusuario;                
                if (accion==1){
                    this.adAccion=1;
                }
                else if (accion==2){
                    this.adAccion=2;
                }
                else{
                    this.adModal=0;
                }
            },
            activarDesactivarCerrar(){
                this.adModal=0;
            },
      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.close()
      },
    },
  mounted(){
  }
  }

</script>
My CRUD